import { render, staticRenderFns } from "./LoginComponentInputMail.vue?vue&type=template&id=87fb65f4"
import script from "./LoginComponentInputMail.vue?vue&type=script&lang=ts"
export * from "./LoginComponentInputMail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports